export default {
    PackageLookup: {
        PackageServicesList: {
            "Family ID Restoration Pro with $25k insurance":
                '<p>All the identity protection essentials – designed for families.</p> <ul class="bulleted_list serviceDescription">     <li>Online Identity Vault<sup>&trade;</sup></li>     <li>Password Manager</li>     <li>24/7 live support</li>     <li>Fully-managed identity restoration services extended to family</li>     <li>Personalized Identity Reports</li>     <li>Free mobile app</li>     <li>Up to $25K for expenses incurred during identity restoration</li> </ul>',
            "Dark Web Monitoring": '<ul class="bulleted_list serviceDescription">      <li>Detect fraudsters trading your information on the Dark Web</li> </ul>',
        },
        packagDetails: [
            {
                childPackagDetails: {
                    ChildPackageServicesList: {},
                    PackageName: null,
                    PackageType: null,
                    PackagePrice: null,
                    IsPopulaer: null,
                    DisplayOrderValue: null,
                    PackageServices: null,
                },
                PackageName: "Enhanced EE Paid Parent",
                PackageType: "USERFPS",
                Persona: "Individual",
                PackagePrice: null,
                MonthlySubscriptionPrice: "5.0000",
                YearlySubscriptionPrice: "",
                DiscountedPackagePrice: null,
                IsPopulaer: "False",
                SubscriptionType: "/mo",
                SmbLicensePrices: {},
                PackageServices: null,
                PackageServiceslst: [
                    {
                        ServiceName: "Family ID Restoration Pro with $25k insurance",
                        ProductName: "SVCLVL-IDR-FR-ITI2P",
                        ServiceCode: "EZFRITI2P",
                        ServicePrice: 4.95,
                        DiscountedServicePrice: null,
                        IsServiceBelongsToIDF: false,
                        Product: 71,
                    },
                    {
                        ServiceName: "Dark Web Monitoring",
                        ProductName: "SVC-INTMON",
                        ServiceCode: "EZINTMON",
                        ServicePrice: 2.95,
                        DiscountedServicePrice: null,
                        IsServiceBelongsToIDF: false,
                        Product: 55,
                    },
                ],
                DisplayOrderValue: "0",
            },
        ],
        smbLicenseLimits: {},
    },
    UserType: "Business",
    MonitorPrimaryEmail: false,
    DisplayLast4SSN: false,
    DisplayFullSSN: false,
    DisplayDOB: false,
    BillingRequired: true,
    BillingOptions: {
        SupportedBillingType: ["Month", "year"],
        FreeTrialInfo: {
            LengthInDays: 30,
            "Description: ": "30 Day FREE Trial",
            BillingStartDate: "1-12-2020",
        },
        CartPrice: {
            MonthlyPrice: 7.0,
            AnnualPrice: 70.0,
            PSSPrice: 0,
        },
        BillingCycleAnnualDescription: "depending on what is configured at partner level",
        PaymentOptions: {
            PaymentMethod: {
                Options: ["CC", "EFT"],
                Selection: "CC",
                Name: "Credit Card",
                SubscriptionType: null,
            },
            CreditCard: {
                CardType: {
                    Options: ["VISA", "MASTERCARD", "DISCOVER", "AMEX"],
                    Selection: "AMEX",
                    ReadOnly: true,
                },
            },
            EFT: {
                NameOnAccount: null,
                RoutingNumber: [],
                AccountNumber: null,
                BankName: null,
                AccountType: {
                    Options: ["Consumer Checking", "Consumer Savings", "Commercial Checking"],
                    Selection: null,
                    ReadOnly: false,
                },
            },
        },
    },
    RoutingNumberRequired: false,
    UserData: {
        FirstName: "Donald",
        Lastname: "Blair",
        Email: "donaldblair@gmail.com",
        DOB: "",
        Zipcode: "",
    },
};

export const registerPageUserData = {
    personalUserData: {
        step1: {
            title1: "Personal Information 1 of 2",
            title2: "Personal Information 2 of 2",
            street: "Street",
        },
        step2: {
            isSameAddress: "Same as Personal Address",
        },
    },
    BusinessUserData: {
        step1: {
            title1: "Business Information 1 of 2",
            title2: "Business Information 2 of 2",
            street: "Business Street",
        },
        step2: {
            isSameAddress: "Same as Business Address",
        },
    },
};
